import React, { lazy } from 'react';

const JobsPage = lazy(() => import('./JobsPage'));

const JobsConfig = {
	routes: [
		{
			path: '/apps/jobs',
			element: <JobsPage />
		}
	]
};

export default JobsConfig;
